import * as Yup from "yup";

const yupEoiLocale = {
  mixed: {
    required: "${path} is needed to apply",
  },
  string: {
    min: "${path} must be at least ${min} characters",
    max: "${path} must be no more than ${max} characters",
  },
  number: {
    lessThan: "${path} must be before ${less}",
    moreThan: "${path} must be after ${more}",
  },
};

Yup.setLocale(yupEoiLocale);

const CURRENT_YEAR = new Date().getFullYear();
const MIN_YOB = CURRENT_YEAR - 101;
const MAX_YOB = CURRENT_YEAR;
const TEXT_FIELD_MAX_LENGTH = 50;

export const NAME_REGEX =
  /^[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF][a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF'\-\s]*[a-zA-ZÀ-ÿ\u0100-\u017F\u0180-\u024F\u1E00-\u1EFF]$/;

export const eoiSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .label("First name")
    .required()
    .min(2)
    .max(TEXT_FIELD_MAX_LENGTH)
    .matches(NAME_REGEX, "Please enter only valid characters")
    .nullable(),
  lastName: Yup.string()
    .trim()
    .label("Last name")
    .required()
    .min(2)
    .max(TEXT_FIELD_MAX_LENGTH)
    .matches(NAME_REGEX, "Please enter only valid characters")
    .nullable(),
  phone: Yup.string()
    .matches(/^[\d ()+-]+$/, "This is not a valid phone number")
    .required()
    .label("Phone number")
    .nullable(),
  email: Yup.string()
    .email("This is not a valid email address")
    .required()
    .label("Email address")
    .nullable(),
  gender: Yup.number().nullable(),
  qualification: Yup.string().max(500).label("Qualification").nullable(),
  /* IMPORTANT: This regex is duplicated in 3 places and must stay in sync:
  1. Backend: SeekVolunteer.Web/Validators/EoiValidator.cs
  2. Frontend Schema: @skv/core eoiSchema.ts (this file)
  3. Widget: EoiForm.tsx
  Pattern: ^https?:\/\/(www\.)?(?:au|nz)\.seek\.com\/profiles?\/[a-zA-Z0-9-]{3,}\/?$
  const shareableLinkRegex = new RegExp(
    /^https?:\/\/(www\.)?(?:au|nz)\.seek\.com\/profiles?\/[a-zA-Z0-9-]{3,}\/?$/,
  );*/
  shareableLink: Yup.string()
    .label("Link")
    .matches(
      /^https?:\/\/(www\.)?(?:au|nz)\.seek\.com\/profiles?\/[a-zA-Z0-9-]{3,}\/?$/,
      {
        excludeEmptyString: true,
        message: "Link doesn't appear to be valid",
      }
    )
    .notRequired()
    .nullable(),
  yearOfBirth: Yup.number()
    .moreThan(MIN_YOB)
    .lessThan(MAX_YOB)
    .transform((value, ogValue) => {
      if (typeof ogValue === "string" && ogValue === "") {
        return null;
      }
      return value;
    })
    .nullable()
    .typeError(
      `Year of Birth must be a number between ${MIN_YOB} and ${MAX_YOB}`
    )
    .label("Year of Birth"),
  location: Yup.string()
    .required()
    .label("Location")
    .typeError("Location is needed to apply")
    .nullable(),
}).defined();
